import React, { useMemo } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { CheckIcon } from '@heroicons/react/solid';
import clsx from 'clsx';

type Props = {
  data: Array<any>;
};

const CourseDetails = (props: Props) => {
  const { data } = props;

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'firstName',
        headerName: 'Naam',
        flex: 2,
        valueGetter: (params: any) => {
          return `${params.row.user.firstName} ${params.row.user.lastName}`;
        },
      },
      {
        field: 'course',
        headerName: 'Cursus',
        flex: 2,
        valueGetter: (params: any) => {
          return params.row.course.title;
        },
      },
      {
        field: 'modules',
        headerName: 'Voortgang',
        flex: 0.75,
        valueGetter: (params: any) => {
          const finishedModules = params.row.modules.filter(
            (module: any) => module.status === 'completed'
          ).length;
          return `${finishedModules}/${params.row.modules.length}`;
        },
      },
      {
        field: 'action',
        headerName: 'Afgerond',
        flex: 0.75,
        renderCell: (params) => {
          const finishedModules = params.row.modules.filter(
            (module: any) => module.status === 'completed'
          ).length;
          const completed = finishedModules === params.row.modules.length;
          return (
            <CheckIcon
              className={clsx(
                'w-5 ',
                completed ? 'flex w-5 text-sky' : 'text-grey-medium_light'
              )}
            />
          );
        },
      },
    ];
  }, []);

  return (
    <DataGrid
      autoHeight
      rows={data}
      columns={columns}
      getRowId={(row) => row._id}
    />
  );
};

export default CourseDetails;
